module.exports = __webpack_public_path__ + "static/media/mediaIcon.674dcb33.svg";